import {Component, EventEmitter, OnInit, Output} from '@angular/core';
import {User} from "../../../model/user";


@Component({
  selector: 'app-home-page',
  templateUrl: './home-page.component.html',
  styleUrls: ['./home-page.component.css']
})
export class HomePageComponent implements OnInit {
  user: User;
  @Output() selectEvent = new EventEmitter();


  constructor() {
    console.log("Home")
  }

  ngOnInit() {
    console.log("Home")
    this.user = JSON.parse(sessionStorage.getItem("user"));
  }



}
